<!-- TEMPLATE -->
<template>
  <div class='provisioning-services-settings'>
    <dean-two-column-layout :title="headerTitle">
      <dean-section-title-item
          :icon="saveIcon"
          slot="title-items"
          :content="true"
          :large="true"
          @click.native="save"
      >
        Opslaan
      </dean-section-title-item>

      <div class="column" slot="left">
        <fade-transition group>
          <dean-form-row
              key="name"
              id="name"
              label="Name"
              v-model="data.name"
              type="text"
              :required-field="true"
              :warning="$v.data.name.$error"
              @focus="$v.data.name.$touch()"
          />

          <dean-form-row
              key="subscriptionType"
              id="subscriptionType"
              label="Subscription Type"
              v-model="data.subscriptionType"
              type="text"
              :requiredField="true"
              :warning="$v.data.subscriptionType.$error"
          />

          <dean-form-row
              key="providerEnvironment"
              id="providerEnvironment"
              label="Provider Environment"
              v-model="data.providerEnvironment"
              type="text"
              :requiredField="true"
              :warning="$v.data.providerEnvironment.$error"
          />

          <dean-form-row
              key="dataUsageNotification"
              id="dataUsageNotification"
              label="Data Usage Notification"
              v-model="data.dataUsageNotification"
              type="text"
              :requiredField="true"
              :warning="$v.data.dataUsageNotification.$error"
          />

          <dean-form-row
              key="dataRoamingLimitation"
              id="dataRoamingLimitation"
              label="Data Roaming Limitation"
              v-model="data.dataRoamingLimitation"
              type="text"
              :requiredField="true"
              :warning="$v.data.dataRoamingLimitation.$error"
          />

          <dean-input-switch-form-row
              key="blockData"
              id="blockData"
              :value="data.blockData"
              @checked="blockDataChanged"
              label="Block Data"
          />

          <dean-input-switch-form-row
              key="voiceMail"
              id="voiceMail"
              :value="data.voiceMail"
              @checked="voiceMailChanged"
              label="Voice Mail"
          />

          <dean-input-switch-form-row
              key="voiceRoaming"
              id="voiceRoaming"
              :value="data.voiceRoaming"
              @checked="voiceRoamingChanged"
              label="Voice Roaming"
          />

          <dean-input-switch-form-row
              key="internationalDialing"
              id="internationalDialing"
              :value="data.internationalDialing"
              @checked="internationalDialingChanged"
              label="International Dialing"
          />

          <dean-input-switch-form-row
              key="premiumServices"
              id="premiumServices"
              :value="data.premiumServices"
              @checked="premiumServicesChanged"
              label="Premium Services"
          />

          <dean-input-switch-form-row
              key="entertainmentServices"
              id="entertainmentServices"
              :value="data.entertainmentServices"
              @checked="entertainmentServicesChanged"
              label="Entertainment Services"
          />

          <dean-input-switch-form-row
              key="internetAccess"
              id="internetAccess"
              :value="data.internetAccess"
              @checked="internetAccessChanged"
              label="Internet Access"
          />

          <dean-input-switch-form-row
              key="superFast"
              id="superFast"
              :value="data.superFast"
              @checked="superFastChanged"
              label="Super Fast"
          />

          <dean-input-switch-form-row
              key="mobilePay"
              id="mobilePay"
              :value="data.mobilePay"
              @checked="mobilePayChanged"
              label="Mobile Pay"
          />

          <dean-input-switch-form-row
              key="extraSecureMobile"
              id="extraSecureMobile"
              :value="data.extraSecureMobile"
              @checked="extraSecureMobileChanged"
              label="Extra Secure Mobile"
          />

          <dean-input-switch-form-row
              key="dataRoamingEU"
              id="dataRoamingEU"
              :value="data.dataRoamingEU"
              @checked="dataRoamingEUChanged"
              label="Data Roaming EU"
          />

          <dean-input-switch-form-row
              key="notificationInfo"
              id="notificationInfo"
              :value="data.notificationInfo"
              @checked="notificationInfoChanged"
              label="Notification Info"
          />

          <dean-input-switch-form-row
              key="unlimitedVoiceNLEUGroup"
              id="unlimitedVoiceNLEUGroup"
              :value="data.unlimitedVoiceNLEUGroup"
              @checked="unlimitedVoiceNLEUGroupChanged"
              label="Unlimited Voice NL/EU Group"
          />

          <dean-input-switch-form-row
              key="dataRoamingLimitationNotification"
              id="dataRoamingLimitationNotification"
              :value="data.dataRoamingLimitationNotification"
              @checked="dataRoamingLimitationNotificationChanged"
              label="Data Roaming Limitation Notification"
          />

          <dean-input-switch-form-row
              key="dataRoamingLimitationOverrideAllowed"
              id="dataRoamingLimitationOverrideAllowed"
              :value="data.dataRoamingLimitationOverrideAllowed"
              @checked="dataRoamingLimitationOverrideAllowedChanged"
              label="Data Roaming Limitation Override Allowed"
          />

          <dean-input-switch-form-row
              key="dataRoamingOutsideEU"
              id="dataRoamingOutsideEU"
              :value="data.dataRoamingOutsideEU"
              @checked="dataRoamingOutsideEUChanged"
              label="Data Roaming Outside EU"
          />

          <dean-input-switch-form-row
              key="blockExceptionCountries"
              id="blockExceptionCountries"
              :value="data.blockExceptionCountries"
              @checked="blockExceptionCountriesChanged"
              label="Block Exception Countries"
          />

          <dean-input-switch-form-row
              key="blockSatelliteDestinations"
              id="blockSatelliteDestinations"
              :value="data.blockSatelliteDestinations"
              @checked="blockSatelliteDestinationsChanged"
              label="Block Satellite Destinations"
          />

          <dean-input-switch-form-row
              key="benefitCountriesA15000MB"
              id="benefitCountriesA15000MB"
              :value="data.benefitCountriesA15000MB"
              @checked="benefitCountriesA15000MBChanged"
              label="Benefit Countries A 15000MB"
          />

          <dean-input-switch-form-row
              key="benefitCountriesA15000MBMax"
              id="benefitCountriesA15000MBMax"
              :value="data.benefitCountriesA15000MBMax"
              @checked="benefitCountriesA15000MBMaxChanged"
              label="Benefit Countries A 15000MB Max"
          />

          <dean-input-switch-form-row
              key="benefitCountriesB7500MB"
              id="benefitCountriesB7500MB"
              :value="data.benefitCountriesB7500MB"
              @checked="benefitCountriesB7500MBChanged"
              label="Benefit Countries B 7500MB"
          />

          <dean-input-switch-form-row
              key="benefitCountriesB7500MBMax"
              id="benefitCountriesB7500MBMax"
              :value="data.benefitCountriesB7500MBMax"
              @checked="benefitCountriesB7500MBMaxChanged"
              label="Benefit Countries B 7500MB Max"
          />

          <dean-input-switch-form-row
              key="restOfTheWorld5000MB"
              id="restOfTheWorld5000MB"
              :value="data.restOfTheWorld5000MB"
              @checked="restOfTheWorld5000MBChanged"
              label="Rest of the World 5000MB"
          />

          <dean-input-switch-form-row
              key="restOfTheWorld5000MBMax"
              id="restOfTheWorld5000MBMax"
              :value="data.restOfTheWorld5000MBMax"
              @checked="restOfTheWorld5000MBMaxChanged"
              label="Rest of the World 5000MB Max"
          />

          <dean-input-switch-form-row
              key="worldBundle7500MB"
              id="worldBundle7500MB"
              :value="data.worldBundle7500MB"
              @checked="worldBundle7500MBChanged"
              label="World Bundle 7500MB"
          />

          <dean-input-switch-form-row
              key="worldBundle7500MBMax"
              id="worldBundle7500MBMax"
              :value="data.worldBundle7500MBMax"
              @checked="worldBundle7500MBMaxChanged"
              label="World Bundle 7500MB Max"
          />
        </fade-transition>
      </div>
    </dean-two-column-layout>
  </div>
</template>

<script lang="ts">
import {Vue, Component} from 'vue-property-decorator';
import {
  deanSectionTitleItem,
  saveIcon,
} from '@deanone/dean-components';
import DeanFormRow from '@/components/deanComponents/deanFormRow.vue';
import DeanTwoColumnLayout from '@/components/deanComponents/deanTwoColumnLayout.vue';
import deanInputSwitchFormRow from '@/components/deanComponents/deanInputSwitchFormRow.vue';
import {FadeTransition} from 'vue2-transitions';
import {validationMixin} from 'vuelidate';
import {required} from 'vuelidate/lib/validators';
import {Validations} from 'vuelidate-property-decorators';
import {createNotification} from '@/mixins/validations';
import {processKpnProduct} from "@/store/standingData/actions";

@Component({
  components: {
    deanInputSwitchFormRow,
    deanSectionTitleItem,
    DeanFormRow,
    DeanTwoColumnLayout,
    FadeTransition,
  },
  mixins: [validationMixin],
})
export default class Details extends Vue {
  // DATA
  public data: any = {
    name: '',
    subscriptionType: '',
    providerEnvironment: '',
    dataUsageNotification: '',
    blockData: false,
    voiceMail: false,
    voiceRoaming: false,
    internationalDialing: false,
    premiumServices: false,
    entertainmentServices: false,
    internetAccess: false,
    superFast: false,
    mobilePay: false,
    extraSecureMobile: false,
    dataRoamingEU: false,
    notificationInfo: false,
    unlimitedVoiceNLEUGroup: false,
    dataRoamingLimitation: '',
    dataRoamingLimitationNotification: false,
    dataRoamingLimitationOverrideAllowed: false,
    dataRoamingOutsideEU: false,
    blockExceptionCountries: false,
    blockSatelliteDestinations: false,
    benefitCountries250MB: false,
    benefitCountriesA15000MB: false,
    benefitCountriesA15000MBMax: false,
    benefitCountriesB7500MB: false,
    benefitCountriesB7500MBMax: false,
    restOfTheWorld5000MB: false,
    restOfTheWorld5000MBMax: false,
    worldBundle7500MB: false,
    worldBundle7500MBMax: false
  };
  public name: string = '';
  public saveIcon: any = saveIcon;

  // COMPUTED
  get headerTitle(): string {
    return this.$route.params.id ? 'KPN Product bewerken' : 'KPN Product toevoegen';
  }

  @Validations()
  get validations() {
    return {
      data: {
        name: { required },
        subscriptionType: { required },
        providerEnvironment: { required },
        dataUsageNotification: { required },
        dataRoamingLimitation: { required }
      }
    };
  }

  // METHODS
  public blockDataChanged(event: any): void {
    this.data.blockData = event.value;
  }

  public voiceMailChanged(event: any): void {
    this.data.voiceMail = event.value;
  }

  public voiceRoamingChanged(event: any): void {
    this.data.voiceRoaming = event.value;
  }

  public internationalDialingChanged(event: any): void {
    this.data.internationalDialing = event.value;
  }

  public premiumServicesChanged(event: any): void {
    this.data.premiumServices = event.value;
  }

  public entertainmentServicesChanged(event: any): void {
    this.data.entertainmentServices = event.value;
  }

  public internetAccessChanged(event: any): void {
    this.data.internetAccess = event.value;
  }

  public superFastChanged(event: any): void {
    this.data.superFast = event.value;
  }

  public mobilePayChanged(event: any): void {
    this.data.mobilePay = event.value;
  }

  public extraSecureMobileChanged(event: any): void {
    this.data.extraSecureMobile = event.value;
  }

  public dataRoamingEUChanged(event: any): void {
    this.data.dataRoamingEU = event.value;
  }

  public notificationInfoChanged(event: any): void {
    this.data.notificationInfo = event.value;
  }

  public unlimitedVoiceNLEUGroupChanged(event: any): void {
    this.data.unlimitedVoiceNLEUGroup = event.value;
  }

  public dataRoamingLimitationNotificationChanged(event: any): void {
    this.data.dataRoamingLimitationNotification = event.value;
  }

  public dataRoamingLimitationOverrideAllowedChanged(event: any): void {
    this.data.dataRoamingLimitationOverrideAllowed = event.value;
  }

  public dataRoamingOutsideEUChanged(event: any): void {
    this.data.dataRoamingOutsideEU = event.value;
  }

  public blockExceptionCountriesChanged(event: any): void {
    this.data.blockExceptionCountries = event.value;
  }

  public blockSatelliteDestinationsChanged(event: any): void {
    this.data.blockSatelliteDestinations = event.value;
  }

  public benefitCountriesA15000MBChanged(event: any): void {
    this.data.benefitCountriesA15000MB = event.value;
  }

  public benefitCountriesA15000MBMaxChanged(event: any): void {
    this.data.benefitCountriesA15000MBMax = event.value;
  }

  public benefitCountriesB7500MBChanged(event: any): void {
    this.data.benefitCountriesB7500MB = event.value;
  }

  public benefitCountriesB7500MBMaxChanged(event: any): void {
    this.data.benefitCountriesB7500MBMax = event.value;
  }

  public restOfTheWorld5000MBChanged(event: any): void {
    this.data.restOfTheWorld5000MB = event.value;
  }

  public restOfTheWorld5000MBMaxChanged(event: any): void {
    this.data.restOfTheWorld5000MBMax = event.value;
  }

  public worldBundle7500MBChanged(event: any): void {
    this.data.worldBundle7500MB = event.value;
  }

  public worldBundle7500MBMaxChanged(event: any): void {
    this.data.worldBundle7500MBMax = event.value;
  }

  public async save(): Promise<void> {
    this.$v.$touch();
    if (this.$v.$invalid) {
      createNotification(this);
      return;
    }

    this.$store.dispatch('setLoadOverlay', true);
    try {
      const response = await this.$store.dispatch('processKpnProduct', {
        ...this.data,
        identifier: this.$route.params.id,
      });

      if (!this.$route.params.id) {
        this.$router.push({
          name: 'standingData.kpnProducts.edit',
          params: { id: response.data.identifier }
        });
      }
      this.$toast(this.$store.state.main.notification.messages.dataSaved);
    } catch (error) {
      this.$toast(this.$store.state.main.notification.messages.couldNotSaveData);
    } finally {
      this.$store.dispatch('setLoadOverlay', false);
    }
  }

  public async created(): Promise<void> {
    if (this.$route.params.id) {
      this.$store.dispatch('setLoadOverlay', true);
      try {
        const response = await this.$store.dispatch('requestKpnProductInfo', {
          identifier: this.$route.params.id,
        });
        this.data = response.data;
      } catch (error) {
        this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
      } finally {
        this.$store.dispatch('setLoadOverlay', false);
      }
    }
  }
}
</script>

<!-- STYLE -->
<style lang="scss" scoped>
@import '~@deanone/dean-components/src/scss/vars';

.provisioning-services-settings {
  .column {
    padding: 0;
  }
}
</style>